import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";

interface MovieCardProps {
  item: MediaItem;
  kind?: "movie" | "tv";
}

export default function MovieCard({ item, kind = "movie" }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block overflow-hidden rounded-lg bg-background-100 border border-background-200 transition-colors duration-300 hover:border-accent-300"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={item.cover}
          alt={`${item.title} 影视海报`}
          title={`${item.title} 剧照海报`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute top-2 left-2 flex flex-wrap gap-1">
          {item.tags.slice(0, 1).map((tag) => (
            <span
              key={tag}
              className="rounded-md bg-accent-500 px-1.5 py-0.5 text-[11px] font-medium text-background-50 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
        <span className="absolute bottom-2 right-2 flex items-center gap-0.5 rounded-md bg-primary-950/80 px-1.5 py-0.5 text-[11px] font-medium text-background-50">
          <i className="ri-star-fill text-accent-400 text-[11px]" />
          {item.rating.toFixed(1)}
        </span>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-medium text-foreground-950 group-hover:text-primary-600 transition-colors">
          {item.title}
        </h3>
        <p className="mt-1 truncate text-xs text-foreground-500">
          {item.year} · {item.genres.slice(0, 2).join(" ")}
        </p>
        <p className="mt-0.5 flex items-center gap-1 truncate text-[11px] text-foreground-400">
          <i className="ri-movie-2-line" />
          {kind === "tv" && item.episodes ? `全 ${item.episodes} 集` : item.region}
        </p>
      </div>
    </Link>
  );
}